import type { EventListItem } from './types';

/** Missing delivery-address placeholder — mirrors the em-dash used for missing times. */
const MISSING_ADDRESS_PLACEHOLDER = '—';

/**
 * Primary "Delivery details" label for the events list (desktop table + mobile
 * card). Self-pickup events read "Self-pickup" regardless of any stored
 * logistics address; delivery events show their address, or an em-dash when no
 * address is set yet. A delivery event without an address must never fall back
 * to the pickup label — that mislabels a delivery as self-pickup.
 */
export function formatEventDeliveryLabel(
  event: Pick<EventListItem, 'fulfilmentType' | 'deliveryAddress'>,
  t: (key: string) => string,
): string {
  if (event.fulfilmentType === 'self_pickup') return t('self_pickup_label');
  return event.deliveryAddress || MISSING_ADDRESS_PLACEHOLDER;
}
